module.exports = __webpack_public_path__ + "img/title1.d30bcd41.png";